import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_LESSON_PAGINATION } from "../Schema/Lesson";

const useGetLessonPagination = ({ classId }) => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);
  const [keyword, setKeyword] = useState("");
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState();

  const { error, refetch } = useQuery(GET_LESSON_PAGINATION, {
    variables: {
      page,
      limit,
      pagination: true,
      keyword: keyword ?? "",
      // classId: contentId ? contentId : "",
      classId: classId ? classId : "",
    },
    onCompleted: ({ getLessonPagination }) => {
      setTableData(getLessonPagination?.data);
      setPaginationData(getLessonPagination?.paginator);
      setLoading(false);
    },
  });

  useEffect(() => {
    if (error) {
      console.error("Error fetching lesson:", error.message);
    }
  }, [error]);

  const handleSearch = (e) => {
    setPage(1);
    setKeyword(e.target.value);
  };

  const handleLimit = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  return {
    page,
    limit,
    setPage,
    refetch,
    loading,
    setLoading,
    error,
    handleSearch,
    tableData,
    paginationData,
    handleLimit,
  };
};

export default useGetLessonPagination;
